import type { FC } from 'react'

import { Combobox, LoaderCircle } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'

import queries from '../../queries'
import adminResources from '../../resources'
import type { Customer } from '../../resources'

export const Company: FC = () => {
  const translate = useTranslation()

  const { data: customers, isLoading: isCustomersLoading } = useQuery(
    queries.adminCustomers(),
    adminResources.getCustomers
  )

  if (isCustomersLoading) {
    return (
      <div className="mx-2 grid grid-cols-2 gap-4 rounded-lg">
        <LoaderCircle />
      </div>
    )
  }

  return (
    <div>
      <Field name="customerId">
        {({ field, meta, form }: FieldProps) => (
          <Combobox
            id="customerId"
            capitalizeLabel
            isFullWidth
            hitsTranslation={<Translation id="hit(s)" />}
            noResultsFoundTranslation={<Translation id="No results found" />}
            marginBottom={16}
            label={
              <>
                <Translation id="Company" />*
              </>
            }
            ariaLabel={translate('Company')}
            list={customers || []}
            stringMatcher={(item: Customer | null) => (item ? `${item.name} ${item.orgNo}` : '')}
            touched={meta.touched}
            error={meta.error}
            placeholder={translate('Choose company...')}
            onSetFieldTouched={() => form.setFieldTouched('customerId')}
            {...field}
            onSetFieldValue={(v: string) => {
              const customerId = customers?.find(
                customer => `${customer.name} ${customer.orgNo}` === v
              )?.id
              form.setFieldValue('customerId', customerId || '')
              // Reset department and address due to different selection based on the selected customer id
              form.setFieldValue('customerAddressId', '')
              form.setFieldValue('departmentId', '')
            }}
          />
        )}
      </Field>
    </div>
  )
}
